<template>
	<b-popover placement="right" boundary="viewport" trigger="hover" :target="'popover_'+site.siteID" @show="setPopoverMap(site.siteID,true)" @hide="setPopoverMap(site.siteID,false)" no-fade>
	  <div>
	    <site-info v-if="popoverMap[site.siteID]" @action="emitAction" :site="site" @mouseenter.native="setContentHoverMap(site.siteID)" @mouseleave.native="closePopover(site.siteID)"></site-info>
	  </div>
	</b-popover>
</template>

<script>
import Vue from 'vue';
import SiteInfo from '../siteInfo/SiteInfo';

export default {
	name: "sitePopHover",
	components:{
		SiteInfo
	},
	props: ['popoverMap', 'site', 'contentHoverMap'],
	methods:{
		setPopoverMap(siteID, value) {
		  Vue.set(this.popoverMap, siteID, value);
		},
		setContentHoverMap(siteID) {
			Vue.set(this.contentHoverMap, siteID, true);
		},
		closePopover(siteID) {
		  Vue.set(this.contentHoverMap, siteID, false);
		  this.$root.$emit('bv::hide::popover', 'popover_' + siteID);
		},
		emitAction(payload) {
		  this.$emit('action', payload);
		},
	}

};
</script>